(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('VoiceInputService', VoiceInputService);

    VoiceInputService.$inject = ['$q', '$http', '$log', '$window'];

    function VoiceInputService($q, $http) {
        var mediaRecorder;
        var audioChunks = [];

        var service = {
            startRecording: startRecording,
            stopRecording: stopRecording,
            sendAudioForTranscription: sendAudioForTranscription,
            sendAudioForTranscriptionGenerationIA: sendAudioForTranscriptionGenerationIA,
        };

        return service;

        function startRecording(stream) {
            var deferred = $q.defer();

            try {
                mediaRecorder = new MediaRecorder(stream);
                audioChunks = [];

                mediaRecorder.addEventListener(
                    'dataavailable',
                    function (event) {
                        audioChunks.push(event.data);
                    }
                );

                mediaRecorder.addEventListener('error', function (error) {
                    deferred.reject('Error recording: ' + error.message);
                });

                mediaRecorder.start();
                deferred.resolve();
            } catch (error) {
                deferred.reject(
                    'Error configuring recording: ' + error.message
                );
            }

            return deferred.promise;
        }

        function stopRecording() {
            var deferred = $q.defer();

            if (!mediaRecorder) {
                deferred.reject('Recorder not started');
                return deferred.promise;
            }

            try {
                mediaRecorder.addEventListener('stop', function () {
                    try {
                        var audioBlob = new Blob(audioChunks, {
                            type: mediaRecorder.mimeType || voiceInputConstants.VOICE.FALLBACK_AUDIO_TYPE,
                        });
                        var tracks = mediaRecorder.stream.getTracks();
                        tracks.forEach(function (track) {
                            track.stop();
                        });
                        deferred.resolve(audioBlob);
                    } catch (error) {
                        deferred.reject(
                            'Error processing audio: ' + error.message
                        );
                    }
                });

                mediaRecorder.stop();
            } catch (error) {
                deferred.reject('Error stopping recording: ' + error.message);
            }

            return deferred.promise;
        }

        /**
         * Receives an audio file and returns the transcribed text using Speech-to-text GCP HTTP Rest
         * @param audioBlob
         * @returns {*}
         */
        function sendAudioForTranscription(audioBlob) {
            var deferred = $q.defer();

            if (!audioBlob) {
                deferred.reject('No audio to transcribe');
                return deferred.promise;
            }

            var formData = new FormData();
            formData.append('file', audioBlob, 'recording');
            var config = {
                headers: {
                    'Content-Type': undefined,
                },
            };

            $http
                .post(
                    '/api/transcription/speech-to-text/file',
                    formData,
                    config
                )
                .then(function (response) {
                    deferred.resolve(response.data.text);
                })
                .catch(function (error) {
                    var errorMsg =
                        'Transcription error: ' +
                        ((error.data && error.data.message) ||
                            error.message ||
                            'Unknown error');
                    deferred.reject(errorMsg);
                });

            return deferred.promise;
        }

        /**
         * Transcribe audio and generate content using Speech-to-Text + Vertex AI
         * @param audioBlob
         * @param contextPrompt
         * @returns {*}
         */
        function sendAudioForTranscriptionGenerationIA(audioBlob, contextPrompt) {
            var deferred = $q.defer();
            if (!audioBlob) {
                deferred.reject('No audio to transcribe');
                return deferred.promise;
            }

            var formData = new FormData();
            formData.append('file', audioBlob, 'recording');
            if (contextPrompt) {
                formData.append('context', contextPrompt);
            }

            var config = {
                headers: {
                    'Content-Type': undefined,
                },
            };

            $http
                .post(
                    '/api/transcription/generate-prompt-from-speech',
                    formData,
                    config
                )
                .then(function (response) {
                    deferred.resolve(response.data.generatedContent);
                })
                .catch(function (error) {
                    var errorMsg =
                        'Transcription error: ' +
                        ((error.data && error.data.message) ||
                            error.message ||
                            'Unknown error');
                    deferred.reject(errorMsg);
                });

            return deferred.promise;
        }

    }
})();
